/* Shared quick-add-to-cart handler for the product-card-square component.
   Used on collection grids and search results. Safe to include more than
   once on a page — the init guard below prevents double-binding.

   Sisters Moto: the slide-out cart (snippets/sm-cart-drawer.liquid, window.SmCart)
   watches every /cart/add request, so after a successful add it opens itself with
   fresh contents and updates the header badge. This file therefore only handles
   the button state and errors. The old toast + badge bump is kept as a fallback
   for pages where the drawer is not present. */
(function () {
  if (window.__quickAddSquareInit) return;
  window.__quickAddSquareInit = true;

  var GENERIC_ERROR = 'Sorry, this item could not be added to your cart.';
  var toast;

  function root() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function showToast(title, cartUrl) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'quick-add-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<span></span><a></a>';
    toast.querySelector('span').textContent = title + ' added to cart';
    var link = toast.querySelector('a');
    link.href = cartUrl;
    link.textContent = 'View cart';
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3500);
  }

  function hasDrawer() {
    return !!(window.SmCart && typeof window.SmCart.open === 'function');
  }

  function showError(message) {
    if (hasDrawer() && typeof window.SmCart.error === 'function') {
      window.SmCart.error(message);
    } else {
      window.alert(message);
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-quick-add]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('.quick-add-btn');
    var card = form.closest('.product-card-square');
    var title = card ? (card.querySelector('.product-title') || {}).textContent || 'Item' : 'Item';
    if (!btn || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    function done() {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: form.querySelector('[name=id]').value, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(
          function (json) { return { ok: r.ok, status: r.status, json: json }; },
          function () { return { ok: r.ok, status: r.status, json: null }; }
        );
      })
      .then(function (res) {
        done();
        if (!res.ok) {
          // 422 = Shopify refused the add (sold out, quantity limit...): tell the shopper why.
          if (res.status === 422) {
            showError((res.json && (res.json.description || res.json.message)) || GENERIC_ERROR);
            return;
          }
          throw new Error('add failed: ' + res.status);
        }
        btn.classList.add('is-done');
        setTimeout(function () {
          btn.classList.remove('is-done');
        }, 2200);
        // The drawer opens itself and updates the badge (sm-cart-drawer.liquid).
        if (hasDrawer()) return;
        showToast(title.trim(), root() + 'cart');
        if (typeof window.updateCartCounter === 'function') window.updateCartCounter();
        else document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {
        done();
        // Unknown failure (network, product needs options...): send the shopper to the product page.
        var link = card ? card.querySelector('a') : null;
        if (link) window.location.href = link.href;
        else showError(GENERIC_ERROR);
      });
  });

  /* Cards of products with real Colour / Size variants (data-sm-variants, snippets/sm-card-core.liquid)
     get their swatches + size buttons from assets/sm-group.js. Collection / search grids load it
     already; on other pages (homepage rows, recommendations, recently viewed...) load it and
     sm-group.css once, when the first such card shows up. The URLs come from the card. */
  var smgAsked = false;
  function loadVariantUi() {
    if (smgAsked) return true;
    var card = document.querySelector('.product-card-square[data-sm-variants][data-smv-js]');
    if (!card) return false;
    smgAsked = true;
    var css = card.getAttribute('data-smv-css');
    if (css && !document.querySelector('link[href*="sm-group.css"]')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = css;
      document.head.appendChild(l);
    }
    // sm-group.js on the page (or loading) watches for new cards itself
    if (window.SmGroup || document.querySelector('script[src*="sm-group.js"]')) return true;
    var s = document.createElement('script');
    s.src = card.getAttribute('data-smv-js');
    s.async = true;
    document.head.appendChild(s);
    return true;
  }
  function watchVariantCards() {
    if (loadVariantUi() || !('MutationObserver' in window) || !document.body) return;
    var timer = null;
    var mo = new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () {
        timer = null;
        if (loadVariantUi()) mo.disconnect();
      }, 60);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchVariantCards);
  else watchVariantCards();
})();
